<template>
  <VPaginationBar
    :totalItems="pagination.total_count"
    :itemsPerPage="pagination.page_size"
    :currentPage="pagination.current_page"
    :totalPages="pagination.page_count"
    :isLoading="isLoading"
    @pageLimitUpdated="_onChangePageLimit"
    @paginate="paginate"
  >
  </VPaginationBar>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";

import VPagination from "@/components/VPagination";
import VPageSwitcher from "@/components/VPageSwitcher";
import VSelect from "@/components/VSelect";

import VPaginationBar from "@/components/VPaginationBar";

export default Vue.component("LettersTemplatesPagination", {
  components: {
    VPagination,
    VPageSwitcher,
    VSelect,
    VPaginationBar
  },

  methods: {
    _onChangePageLimit(item) {
      this.changeItemPerPage(item.value);
      this.fetchLettersTemplatesList({
        page: 1,
        sort: this.sort,
        search: this.search,
        page_size: item.value
      });
    },

    paginate(page) {
      this.changeCurrentPage(page);
      this.fetchLettersTemplatesList({
        page,
        sort: this.sort,
        search: this.search,
        page_size: this.pagination.page_size
      });
    },

    ...mapActions("lettersTemplates", [
      "fetchLettersTemplatesList",
      "changeCurrentPage",
      "changeSort"
    ]),
    ...mapActions("service", ["changeItemPerPage"])
  },

  computed: {
    ...mapGetters("lettersTemplates", [
      "pagination",
      "search",
      "isLoading",
      "sort"
    ])
  },

  destroyed() {
    this.changeCurrentPage(1);
  }
});
</script>
